import { useMutation, useQueryClient } from '@tanstack/react-query';

import UserStore from 'src/app_deprecated/stores/UserStore';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from './get-campaigns';

import type { WorkflowMarketingCampaign } from './get-workflow-campaign';

type SaveCampaignPayload = {
  WorkflowCampaign: WorkflowMarketingCampaign;
};

type SaveCampaignResponse = {
  LastModifiedDateUTC: string;
  MarketingCampaignId: number;
};

export function useSaveWorkflowCampaignMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: WorkflowMarketingCampaign) => {
      const userApiData = UserStore.getApiData(payload);
      const payloadWithLSP = {
        WorkflowCampaign: { ...payload, LspId: userApiData.LspId },
      };
      const res = postData<SaveCampaignPayload, SaveCampaignResponse>({
        endpoint: 'api/marketing-campaign/upsert-workflow-campaign',
        payload: payloadWithLSP,
      });
      return res;
    },
    onSuccess: () => queryClient.invalidateQueries(marketingCampaignsQueryKey),
  });
}
